import { FC } from 'react';

const options = {
	1: {
		locale: 'en-GB',
		settings: {
			day: 'numeric',
			month: 'short',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		} as Intl.DateTimeFormatOptions,
		result: ([day, month, year, time]: string[]) =>
			`${day} ${month}, ${year} · ${time}`,
	},
	2: {
		locale: 'en-GB',
		settings: {
			day: 'numeric',
			month: 'short',
		} as Intl.DateTimeFormatOptions,
		result: ([day, month]: string[]) => `${month} ${day}`,
	},
};

type Props = {
	date: Date;
	option?: keyof typeof options;
	className?: string;
};

const EDateText: FC<Props> = ({ date, option = 1, className }) => {
	if (!date) return null;

	const formattedDate = date.toLocaleString(
		options[option].locale,
		options[option].settings,
	);

	const data = formattedDate.replace(',', '').split(' ');

	return (
		<span className={`${className}`}>
			{options[option].result(data)}
		</span>
	);
};

export default EDateText;
